import { toast } from 'react-toastify';

import { MapperHelper } from './mapper';

const handleErrorNotification = async (error: any) => {
  const { response } = error;

  if (!response) {
    console.log(error);
  }

  if (response?.status === 500) {
    toast.error('Something went wrong');
    return;
  }

  const text = await error?.response?.json();

  if (response?.status !== 201 && !text) {
    toast.error(response?.statusText);
    return;
  }

  toast.error(MapperHelper.jsonToString(text), {
    position: 'top-right',
    theme: 'colored',
    toastId: 'error-toast-notification',
  });
};

export const ErrorHelper = {
  handleErrorNotification,
};
